<div>
  <lms-toolbar [options]="toolbarConfig"> </lms-toolbar>
  <div class="gl-table__container">
    <gl-table
      [id]="licenseListId"
      [dataSource]="datasource"
      [placeholder]="'nouns.empty' | translate"
      (onDatasourceUpdate)="onDatasourceUpdate($event.detail.dataSource)"
    >
    </gl-table>
  </div>
</div>
